<template>
  <div>
    <p
    class="process-repair-tab-section-title mt-5"
    style="font-size: 20px; position: relative; top: 20px;">
      {{$t('pages.repair.addressDetails')}}
    </p>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.companyName')"
        v-model="companyNameProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.country')"
        v-model="countryProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.state')"
        v-model="provinceProp"
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.city')"
        v-model="cityProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.postalCode')"
        v-model="postalCodeProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.street')"
        v-model="streetProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-value 
        :label="$t('textFields.building')"
        v-model="buildingProp"
        required
        :readonly="readonly"
        :disabled="disabled"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextFieldValue from '@/components/text-fields/TextFieldValue'
export default {
  components: {
    TextFieldValue
  },
  props: {
    companyName: String,
    country: String,
    province: String,
    city: String,
    postalCode: String,
    street: String,
    building: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    companyNameProp: {
      get: function() {
        return this.$props.companyName
      },
      set: function(v) {
        this.$emit("update:companyName", v)
      }
    },
    countryProp: {
      get: function() {
        return this.$props.country
      },
      set: function(v) {
        this.$emit("update:country", v)
      }
    },
    provinceProp: {
      get: function() {
        return this.$props.province
      },
      set: function(v) {
        this.$emit("update:province", v)
      }
    },
    cityProp: {
      get: function() {
        return this.$props.city
      },
      set: function(v) {
        this.$emit("update:city", v)
      }
    },
    postalCodeProp: {
      get: function() {
        return this.$props.postalCode
      },
      set: function(v) {
        this.$emit("update:postalCode", v)
      }
    },
    streetProp: {
      get: function() {
        return this.$props.street
      },
      set: function(v) {
        this.$emit("update:street", v)
      }
    },
    buildingProp: {
      get: function() {
        return this.$props.building
      },
      set: function(v) {
        this.$emit("update:building", v)
      }
    }
  }
}
</script>

<style>

</style>